<div mat-dialog-content>
  <h2 class="title text-center">Confirmação de proposta</h2>
  <div class="info-container mx-auto">
    <div class="info">
      <div class="label-container">
        <span class="material-icons icon">person</span>
        <span class="label">Comprador</span>
      </div>
      <div class="value">
        {{vehicle.dealerName}}
      </div>
    </div>
    <div class="info">
      <div class="label-container">
        <span class="material-icons icon">store</span>
        <span class="label">CNPJ</span>
      </div>
      <div class="value">
        {{vehicle.dealerCpfCnpj}}
      </div>
    </div>
    <div class="info" *ngIf="vehicle.dealerEmails">
      <div class="label-container">
        <span class="material-icons icon">email</span>
        <span class="label">Email</span>
      </div>
      <div class="value">
        {{vehicle.dealerEmails[0]}}
      </div>
    </div>
    <div class="info" *ngIf="vehicle.dealerPhoneNumbers">
      <div class="label-container">
        <span class="material-icons icon">phone</span>
        <span class="label">Telefone</span>
      </div>
      <div class="value">
        {{vehicle.dealerPhoneNumbers[0]}}
      </div>
    </div>
    <div class="info">
      <div class="label-container">
        <span class="material-icons icon">place</span>
        <span class="label">Cidade</span>
      </div>
      <div class="value">
        {{vehicle.dealerCity}}/{{vehicle.dealerUf}}
      </div>
    </div>
    <div class="info">
      <div class="label-container">
        <span class="material-icons icon">attach_money</span>
        <span class="label">Valor da proposta</span>
      </div>
      <div class="value proposal">
        {{value | currency:'BRL':'symbol':'1.2-2'}}
      </div>
    </div>
    @if (proposalMargin != null) {
      <div class="info">
        <div class="label-container">
          <span class="material-icons icon">percent</span>
          <span class="label">Margem da proposta</span>
        </div>
        <div class="value">
          {{ proposalMargin | percent:'0.1-1' }}
        </div>
      </div>
    }
    @if (userLimitLabel) {
      <div class="info">
        <div class="label-container">
          <span class="material-icons icon">shield</span>
          <span class="label">Seu limite</span>
        </div>
        <div class="value">
          {{ userLimitLabel }}
        </div>
      </div>
    }
    @if (isMarginBlocked) {
      <p class="margin-block-alert">{{ marginBlockMessage }}</p>
    }
  </div>
  <div class="col-10 mt-4 mb-2 mx-auto">
    <button class="btn btn-white btn-rounded btn-block" [disabled]="isMarginBlocked" (click)="onClickConfirm()">
      <span>
        CONFIRMAR
      </span>
    </button>
    <button class="btn btn-transparent btn-rounded btn-block" style="color: #ff5252" (click)="onNoClick()">CANCELAR</button>
  </div>
</div>